import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './BrandOnboardingDescriptionPanel.scss';

import { updateBrand } from '../../../Actions/BrandActions';
import { getBrand } from '../../../Helpers/user_helpers';
import { isEmpty } from 'lodash';

import BrandOnboardingProgressBar from '../BrandOnboardingProgressBar';

const BrandOnboardingDescriptionPanel = props => {
  const { user } = props;

  const [description, setDescription] = useState(getBrand(user)?.description || '');

  const onNextClick = async () => {
    if (props.isLoading) return;
    else if (!description || description.length < 10) return window.ALERT.error('Please enter a description of your brand (at least 10 characters).');

    const updates = {};
    if (description !== getBrand(user)?.description) updates.description = description;

    if (!isEmpty(updates)) {
      props.setIsLoading(true);
      const brandUpdateResponse = await props.updateBrand(getBrand(user), updates);

      if (brandUpdateResponse.error) {
        props.setIsLoading(false);
        window.ALERT.error('An error occurred while updating your brand. Please try again.');
      } else {
        props.goToNextPanel();
      }
    } else {
      props.goToNextPanel();
    }
  };

  return (
    <div className='brand-onboarding-description-panel-outer'>
      <div className='brand-onboarding-description-panel-inner'>
        <div className='brand-onboarding-split-container-outer'>
          <div className='brand-onboarding-split-container-inner'>
            <div className='brand-onboarding-graphic-container-outer'>
              <div className='brand-onboarding-graphic-container-inner'>
                <div className='brand-onboarding-graphic-container-stat'>
                  <div className='brand-onboarding-graphic-container-stat-label'>Our Numbers</div>
                  <div className='brand-onboarding-graphic-container-stat-number'>{props.featuredStat.number}+</div>
                  <div className='brand-onboarding-graphic-container-stat-description'>{props.featuredStat.description}</div>
                </div>

                <BrandOnboardingProgressBar
                  goToPanel={props.goToPanel}
                  sections={props.sections}
                  activeSectionName={props.activeSectionName}
                  activePanelName={props.activePanelName}
                />
              </div>
              <div className='brand-onboarding-graphic-background'>
                <img className='brand-onboarding-graphic-background-image' src={props.backgroundImage} alt='name panel graphic' />
                <div className='brand-onboarding-graphic-background-overlay'></div>
              </div>
            </div>

            <div className='brand-onboarding-input-container-outer'>
              <div className='brand-onboarding-input-container-number-marker'>{props.panelNumber}</div>

              <div className={cn('brand-onboarding-input-container-inner', { isLoading: props.isLoading })}>
                <div className='brand-onboarding-title-text'>Brand Details</div>
                <div className='brand-onboarding-subtitle-text'>Please provide us with the following information and assets.</div>

                <div className='brand-onboarding-input-label'>Brand Description</div>
                <div className='brand-onboarding-input-sublabel'>A 1-2 sentence description of the brand to be included in your brand profile.</div>
                <textarea
                  className='brand-onboarding-input'
                  type='text'
                  placeholder='Your brand description'
                  onChange={e => setDescription(e.target.value)}
                  value={description}
                  rows='5'
                />

                <div className='brand-onboarding-pagination-buttons'>
                  <button className='brand-onboarding-button stretch' onClick={() => props.goToPreviousPanel()}>
                    Back
                  </button>
                  <button className='brand-onboarding-button stretch primary' onClick={onNextClick}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BrandOnboardingDescriptionPanel.propTypes = {
  user: PropTypes.object.isRequired,
  updateBrand: PropTypes.func.isRequired,

  goToPreviousPanel: PropTypes.func.isRequired,
  goToNextPanel: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps, {
  updateBrand
})(withRouter(BrandOnboardingDescriptionPanel));
